import React from 'react';
import SystemSectionTabsLayout from '../../../shared/ui/system-section-tabs/system-section-tabs-layout.jsx';

const TABS = [
  { key: 'campaigns', label: 'Campaigns', to: '/marketing/emails/campaigns' },
  { key: 'providers', label: 'Provider sync', to: '/marketing/emails/providers' },
  { key: 'settings', label: 'Settings', to: '/marketing/emails/settings' },
];

function MarketingEmailsLayout() {
  return <SystemSectionTabsLayout tabs={TABS} />;
}

export default MarketingEmailsLayout;
